import { Password } from "../../config/config"

const flex = {
  display: 'flex',
  alignItems: 'center'
}

const justifyContent = {
  center: {
    justifyContent: 'center'
  },
  flexEnd: {
    justifyContent: 'flex-end'
  }
}

export const styles = {
  headerSubContainer: {
    ...flex,
    width: '100%',
    height: 70
  },
  rightSubCont: {
    ...flex,
    ...justifyContent.flexEnd,
    width: '60%',
  },
  divider: {
    margin: '5px 25px auto',
    backgroundColor: '#fff',
    height: '2.2rem',
    transform: 'translate(0px, 2px)'
  },
  span: {
    ...flex,
    minWidth: 100,
    marginRight: 10,
    color: '#fff'

  },
  
  userIcon: {
    height: '3rem',
    width: '3rem',
    marginRight: 5,
    color:"#fff"
  },
  logoContainer: {
    width: '40%',
 
    marginLeft: 20,
    textAlign: 'left'
  },
  leftSideLogo:{
     width: "24%"
  },
  PasswordIcon: {
    height: '2rem',
    width: '2rem',
    marginRight: 4
  },
 
}